import { defineComponent } from "vue";
import params from "./params/form-params.vue";
import products from "./product/form-product.vue";

export default defineComponent({
  name: "sdk-flow-task-form",
  components: {
    params,
    products,
  },
  props: {
    closeAction: {
      type: Function,
    },
    taskForm: String,
  },
  data() {
    return {
      screenToDisplay: "products" as "products" | "params",
      tempForm: "",
    };
  },
  methods: {
    applyTempForm(form: string) {
      this.tempForm = form;
      this.screenToDisplay = "params";
    },
  },
  mounted() {
    if (this.taskForm) {
      this.screenToDisplay = "params";
    }
  },
});
